export default __webpack_public_path__ + "static/media/accelerate1.3fa8c6c0.webp";